export const updateFullscreenState = ({ commit, getters }) => {
  const element = gameViewOverlayRef();
  let setElementPointerEvents = 'none';
  let fullscreenState = false;

  if (isFullScreen()) {
    fullscreenState = true;
  } else if (getters.isRegulatory && getters.userDevice === 'm') {
    setElementPointerEvents = 'auto';
  }

  try {
    element.style.pointerEvents = setElementPointerEvents;
  } catch {
    /* Error catcher */
  }

  commit('SUBMIT_FULLSCREEN_STATE', fullscreenState);
};

export const setFullScreenEvents = ({dispatch}) => {
  document.addEventListener('fullscreenchange', () => dispatch('updateFullscreenState'), false);
  document.addEventListener('webkitfullscreenchange', () => dispatch('updateFullscreenState'), false);
  document.addEventListener('mozfullscreenchange', () => dispatch('updateFullscreenState'), false);
  document.addEventListener('msfullscreenchange', () => dispatch('updateFullscreenState'), false);
};

export const toggleFullscreen = async () => {
  const element = gameViewRef();
  try {
    if (isFullScreen()) closeFullScreen();
    else await openFullScreen('', element);
  } catch (err) {
    console.log(err);
  }
};

export const closeFullScreen = () => {
  if(document.exitFullscreen) {
    document.exitFullscreen();
  } else if(document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if(document.mozExitFullscreen) {
    document.mozExitFullscreen();
  } else if(document.msExitFullscreen) {
    document.msExitFullscreen();
  } else {
    // the message has already been given in the request handler
    return false;
  }
};

export const openFullScreen = async (_, element) => {
  if(isFullScreenEnabled()) {
    if(element.requestFullscreen) {
      element.requestFullscreen();
    } else if(element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.mozRequestFullscreen) {
      element.mozRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else {
      console.log('You cannot go in fullscreen due to your browser.');
      return false;
    }
  } else {
    console.log('You did not enable fullscreen in your browser config. You cannot use this feature.');
    return false;
  }
};

const isFullScreenEnabled = () => {
  if(document.fullscreenEnabled) {
    return document.fullscreenEnabled;
  } else if(document.webkitFullscreenEnabled) {
    return document.webkitFullscreenEnabled;
  } else if (document.mozFullscreenEnabled) {
    return document.mozFullscreenEnabled;
  } else {
    return false;
  }
};

const isFullScreen = () => !(!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement);
const gameViewRef = () => document.getElementById('game-view-choice');
const gameViewOverlayRef = () => document.getElementById('game-view-overlay');
